var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 97,
    viewBox: "0 0 73 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5859_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3784 48.5049C50.7727 48.5049 61.6309 37.6467 61.6309 24.2525C61.6309 10.8582 50.7727 0 37.3784 0C23.9842 0 13.126 10.8582 13.126 24.2525C13.126 37.6467 23.9842 48.5049 37.3784 48.5049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3787 56.5703C17.2965 56.5927 1.02236 72.8668 1 92.949C1 95.1814 2.80965 96.991 5.04201 96.991H69.7152C71.9475 96.991 73.7572 95.1814 73.7572 92.949C73.735 72.8668 57.4609 56.5925 37.3787 56.5703Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5859_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 97,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user-white.bbde2ef3a11bb75c37aae85183e65a3a.svg";
export { ForwardRef as ReactComponent };